import { FC } from 'react';
import { iconMap } from './constants';

type IconProperties = {
  icon: keyof typeof iconMap;
  style?: React.CSSProperties;
  size?: number;
  onClick?: () => void;
  color?: React.CSSProperties['color'];
  className?: string;
};

export const Icon: FC<IconProperties> = (props) => {
  const ImportedIcon = iconMap[props?.icon];
  if (!ImportedIcon) return <></>;
  return (
    <ImportedIcon
      className={props?.className}
      {...(props.size ? { width: props?.size, height: props?.size } : {})}
      onClick={() => props.onClick && props.onClick()}
      style={{ ...props?.style, color: props?.color || props?.style?.color }}
    />
  );
};

export default Icon;
